import { Truck } from "@phosphor-icons/react";

const fmt = (v, c = "EUR") =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: c || "EUR" }).format(v || 0);

export default function DeliveryMethodPicker({ methods = [], selected, onSelect, currency = "EUR", invalid = "" }) {
  if (!methods || methods.length === 0) return null;

  return (
    <section
      className={"bg-white rounded-xl p-5 transition-colors " + (invalid
        ? "border-2 border-[#DC2626] ring-2 ring-red-100 bg-red-50/40"
        : "border border-[#E5E7EB]")}
      data-testid="delivery-method-section">
      <h2 className="text-base font-black tracking-tighter text-[#0F1829] flex items-center gap-2 mb-4" style={{ fontFamily: "'Fraunces', sans-serif" }}>
        <Truck size={18} className={invalid ? "text-[#DC2626]" : "text-[#002480]"} />
        Forma de Envio
      </h2>
      {invalid && (
        <p className="mb-3 text-xs font-bold text-[#DC2626] flex items-center gap-1.5" data-testid="delivery-method-invalid">
          <span className="w-4 h-4 rounded-full bg-[#DC2626] text-white text-[10px] grid place-items-center shrink-0">!</span>
          {invalid}
        </p>
      )}
      <div className="space-y-2">
        {methods.map((m) => {
          const id = String(m.ID_TipoTransporte || m.ID || m.id);
          const picked = String(selected) === id;
          const label = m.Descricao || m.descricao || m.Nome || `Transporte ${id}`;
          const price = Number(m.Preco ?? m.Valor ?? 0);
          return (
            <button type="button" key={id} onClick={() => onSelect?.(id)}
              data-testid={`delivery-method-${id}`}
              className={"w-full text-left p-3 rounded-lg border flex items-center gap-3 transition-colors "
                + (picked ? "border-[#0F1829] bg-[#F5F5F2] ring-1 ring-[#0F1829]" : "border-[#E5E7EB] hover:bg-[#F9FAFB]")}>
              <div className={"w-4 h-4 rounded-full shrink-0 border-2 " + (picked ? "border-[#0F1829] bg-[#0F1829]" : "border-[#D1D5DB]")} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-[#0F1829] truncate">{label}</p>
                {m.PrazoEntrega && (
                  <p className="text-xs text-[#6B7280] mt-0.5">Prazo: {m.PrazoEntrega}</p>
                )}
              </div>
              {price > 0 && <span className="text-sm font-semibold text-[#0F1829]">{fmt(price, currency)}</span>}
            </button>
          );
        })}
      </div>
    </section>
  );
}
